module.exports = __webpack_public_path__ + "1a5ebf0c46b497bc2c04c42ff854b135.svg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/plutex.svg
// module id = 948
// module chunks = 0